module.exports = __webpack_public_path__ + "static/media/message_sent_illustration.a4704093.png";